module.exports = __webpack_public_path__ + "img/i-play-mono.e8d09ed0.svg";